<div class="table-detail">
  <div class="table-detail__header">
    <button mat-button (click)="back.emit()">&larr; Back to Tables</button>
    <strong class="table-detail__title">{{ tableName }} — Fields</strong>
  </div>

  <wc-grid gridKey="modelsFields" [context]="gridContext" [showQuickSearch]="true"></wc-grid>
</div>
